function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorldBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-world-bolt",
    clipPath: "url(#clip0_14366_2516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4925 6.25999C10.5464 5.32908 10.3097 4.40442 9.81526 3.61384C9.32082 2.82326 8.59298 2.2058 7.73238 1.84683C6.87178 1.48785 5.92092 1.40509 5.01124 1.60997C4.10156 1.81486 3.27799 2.29728 2.65438 2.99055C2.03078 3.68381 1.63794 4.55367 1.53016 5.47989C1.42239 6.40611 1.60501 7.34294 2.05277 8.16087C2.50053 8.97879 3.19133 9.63742 4.02966 10.0457C4.86799 10.454 5.81245 10.5918 6.73249 10.44M1.80005 4.5H10.2M1.80005 7.5H7.25005M5.75008 1.5C4.90775 2.84981 4.46118 4.40893 4.46118 6C4.46118 7.59107 4.90775 9.15019 5.75008 10.5M6.25 1.5C7.4065 3.353 7.785 5.428 7.385 7.5M9.5 8L8.5 9.5H10.5L9.5 11",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14366_2516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorldBolt);
export default __webpack_public_path__ + "static/media/icon-world-bolt.30f04e51fe99408755e885b3f22c0986.svg";
export { ForwardRef as ReactComponent };